import moment from 'moment';

import { Icon } from '../../UI';

import { TwitterPost } from './types';
import React from 'react';
import { getFormattedValue, truncateString } from '../../../helpers/functions';
import _ from 'lodash';
import { Debug } from '../../Debug/Debug';
import { NumberAbbreviationEnum } from '../../../constants/enums';

export const TwitterCard = ({
  post: {
    createdAt,
    favoriteCount,
    permalink,
    retweet,
    screenName,
    text,
    userImage,
    userName,
    verified,
    id,
  },
}: {
  post: TwitterPost;
}) => {
  const convertToRichText = (str) => {
    str = _.unescape(str);

    const textEls: JSX.Element[] = [];
    let currentText = '';
    let matchTag = '';
    let matchLink = false;

    for (let i = 0; i < str.length; i++) {
      const char = str.slice(i, i + 1);
      const nextChar = str.slice(i + 1, i + 2);
      const isUrlPrefix = str.slice(i, i + 8) === 'https://';
      const isTagPrefix =
        ['$', '@', '#'].includes(char) && /[a-zA-Z]/.test(nextChar);
      const isTagChar = /[a-zA-Z0-9_-]/.test(char);
      const k = 'text_' + i;

      if (!matchTag && isTagPrefix) {
        // hashtag begin
        textEls.push(<span key={k}>{currentText}</span>);
        currentText = char;
        matchTag = char;
      } else if (matchTag && isTagChar) {
        // inside hashtag
        currentText += char;
      } else if (matchTag && !isTagChar) {
        // hashtag ended
        const t = i === str.length - 1 ? currentText + char : currentText;
        textEls.push(
          <span key={k} className={'text-blue-twitter'}>
            {t}
          </span>
        );
        currentText = char;
        matchTag = '';
      } else if (!matchLink && isUrlPrefix) {
        // url begin
        textEls.push(<span key={k}>{currentText}</span>);
        currentText = char;
        matchLink = true;
      } else if (matchLink && char !== ' ') {
        // inside url
        currentText += char;
      } else if (matchLink && char === ' ') {
        // url ended
        const t = i === str.length - 1 ? currentText + char : currentText;
        textEls.push(
          <a href={t} key={k} className={'text-blue-twitter'}>
            {t}
          </a>
        );
        currentText = char;
        matchLink = false;
      } else if (i === str.length - 1) {
        textEls.push(<span key={k}>{currentText + char}</span>);
      } else {
        currentText += char;
      }
    }

    return textEls;
  };

  const richText = convertToRichText(truncateString(text, 160));

  const formattedRetweet = Object.values(
    getFormattedValue(retweet, '', NumberAbbreviationEnum.K, 1)
  ).join(' ');

  const formattedFavorite = Object.values(
    getFormattedValue(favoriteCount, '', NumberAbbreviationEnum.K, 1)
  ).join(' ');
  return (
    <div
      className={`
      flex
      border-grey-10
      dark:border-grey-70
      shadow-md
      border-1
      rounded-lg
      p-4
      cursor-pointer
    `}
      onClick={() => permalink && window.open(permalink, '_blank')}
    >
      <div className={'flex flex-col justify-between w-full'}>
        <div className={'flex justify-between'}>
          <div className={'flex'}>
            <div
              className={'rounded-full bg-black overflow-hidden w-10 h-10 mr-2'}
            >
              <img src={userImage} className={'w-10 mr-2 '} alt={''} />
            </div>
            <div className={'text-sm'}>
              <div className={'font-semibold blue-twitter'}>
                {screenName} {verified && 'verified'}
              </div>
              <div className={'text-grey-70'}>@{userName}</div>
            </div>
          </div>
          <div>
            <Icon
              className="flex text-black cursor-pointer ml-2 w-4"
              svgName={'twitter'}
              color="black"
              canUseDarkMode={false}
            />
          </div>
        </div>
        <div className={'my-2 text-sm overflow-hidden h-full'}>
          <span className={'text-container'}>{richText}</span>
        </div>

        <div
          className={`
          flex
          text-xs
          mt-6
          items-center
          justify-between
          pt-2
          text-grey-70
        `}
        >
          <div className={'flex items-center'}>
            <div className={'flex items-center mr-3'}>
              <Icon svgName="comment" className={'mr-1'} />
              {formattedRetweet}
            </div>

            <Icon svgName="retweet" className={'mr-3'} />

            <div className={'flex items-center mr-3'}>
              <Icon svgName="heart" className={'mr-1'} />
              {formattedFavorite}
            </div>
          </div>

          <div className={'flex items-center self-end'}>
            <div className={'text-xs'}>
              {moment(createdAt).isSame(moment(new Date()), 'd')
                ? moment(createdAt).format('h:mm A')
                : moment(createdAt).format('MMM DD, YYYY')}
            </div>
          </div>
        </div>
        <Debug>
          <div>
            <div>{`ID: ${id}`}</div>
            <div>{`CreatedAt: ${createdAt}`}</div>
            <div>{`Text: ${text}`}</div>
          </div>
        </Debug>
      </div>
    </div>
  );
};
